import { FilterTypes } from 'Core/interfaces'

import { UrlParams } from 'Portals/Customer/constants'
import {
	BackupDocument,
	BackupDocumentFilterFields,
	BackupDocumentSearchSuggestions
} from 'Portals/Customer/entities'
import i18n from 'Portals/Customer/utils/i18nService'

export const getSearchConfig = (): BackupDocument.Search.Config => ({
	[BackupDocumentSearchSuggestions.transactionId]: {
		label: i18n.t('pages:backupDocument.filters.transactionId'),
		apiFieldName: BackupDocumentSearchSuggestions.transactionId,
		apiSearchFieldName: 'TransactionId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.id
	},
	[BackupDocumentSearchSuggestions.serviceOccurrenceId]: {
		label: i18n.t('pages:backupDocument.filters.serviceOccurrenceId'),
		apiFieldName: BackupDocumentSearchSuggestions.serviceOccurrenceId,
		apiSearchFieldName: 'ServiceOccurrenceId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.id
	}
})

export const getFiltersConfig = (): BackupDocument.Filter.Config => ({
	[BackupDocumentFilterFields.startDate]: {
		label: i18n.t('pages:backupDocument.filters.serviceDateFrom'),
		apiFilterFieldName: 'ServiceDateFrom',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.startDate,
		defaultValue: null
	},
	[BackupDocumentFilterFields.endDate]: {
		label: i18n.t('pages:backupDocument.filters.serviceDateTo'),
		apiFilterFieldName: 'ServiceDateTo',
		filterType: FilterTypes.DATE,
		UrlParam: UrlParams.endDate,
		defaultValue: null
	},
	[BackupDocumentFilterFields.serviceSite]: {
		label: i18n.t('pages:backupDocument.filters.serviceSiteId'),
		apiFilterFieldName: 'ServiceSiteId',
		filterType: FilterTypes.ID,
		UrlParam: UrlParams.serviceSiteId,
		defaultValue: ''
	}
})
